export default {"src":"/stays/_next/static/media/MainLogo.77ecabec.svg","height":26,"width":124,"blurWidth":0,"blurHeight":0};